// Light/dark theme. The default look is dark (the original palette in
// global.css `:root`); `data-theme="light"` on <html> swaps in the light
// overrides. "auto" follows the OS preference and updates live.

const KEY = "nyx.prefs.v1.theme";

export type ThemePref = "dark" | "light" | "auto";

export function getThemePref(): ThemePref {
  const v = localStorage.getItem(KEY);
  return v === "light" || v === "dark" || v === "auto" ? v : "dark";
}

function resolve(pref: ThemePref): "light" | "dark" {
  if (pref === "auto") {
    return window.matchMedia("(prefers-color-scheme: light)").matches ? "light" : "dark";
  }
  return pref;
}

export function applyTheme(pref: ThemePref): void {
  document.documentElement.dataset.theme = resolve(pref);
  // Let open views (e.g. the xterm terminal) react to a theme change.
  window.dispatchEvent(new CustomEvent("nyx-theme"));
}

export function setThemePref(pref: ThemePref): void {
  localStorage.setItem(KEY, pref);
  applyTheme(pref);
}

export function initTheme(): void {
  applyTheme(getThemePref());
  window.matchMedia("(prefers-color-scheme: light)").addEventListener("change", () => {
    if (getThemePref() === "auto") applyTheme("auto");
  });
}
